import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { OfferWaterAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-offer-water-slot',
    templateUrl: './offer-water-slot.component.html',
    styleUrl: './offer-water-slot.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OfferWaterSlotComponent implements SheetSlotComponentBase {

	@Input() action!: OfferWaterAction;
	value = null;

	constructor() {
	}
}